<template>
  <div id="headersFornedores">
    <div
      v-if="loading"
      :style="styleObject"
      class="text-center"
    >
      <v-icon
        light
        class="custom-loader"
        :style="styleObject"
      >
        mdi-cached
      </v-icon>
      Carregando dados...
    </div>
    <div
      v-else-if="error"
      class="alert alert-danger"
    >
      {{ error }}
    </div>
    <div
      v-else
    >
      <v-row>
        <v-col
          cols="12"
          sm="12"
          md="12"
          lg="9"
        >
          <v-row v-if="enableBtn">
            <v-col
              id="btnPdf"
              cols="12"
              sm="1"
              md="1"
              lg="1"
            >
              <v-btn
                small
                :color="corPrimaria"
                dark
                :loading="imprimindo"
                @click="imprimirPdf()"
              >
                <v-icon>
                  mdi-printer
                </v-icon>
                Exporta pdf
                <template v-slot:loader>
                  <span>Exportando pdf...</span>
                </template>
              </v-btn>
            </v-col>
            <v-col
              id="btnExcel"
              cols="12"
              sm="1"
              md="1"
              lg="1"
            >
              <v-btn
                small
                :color="corPrimaria"
                dark
                :loading="imprimindoExcel"
                @click="exportExcel()"
              >
                <v-icon>
                  mdi-printer
                </v-icon>
                Exporta excel
                <template v-slot:loader>
                  <span>Exportando excel...</span>
                </template>
              </v-btn>
            </v-col>
          </v-row><br>
          <div
            id="idTable"
            style="overflow-x: auto; max-width: 100%;"
          >
            <table
              style="width: 100%; table-layout: fixed; color: black; border-collapse: collapse;"
              class="elevation-1"
            >
              <thead>
                <tr>
                  <th
                    id="dadoMovimentacaoHeader"
                    style="text-align: center;"
                    class="black--text title"
                    @click="mudarOrdenacao('codCliente')"
                  >
                    Codigo cliente
                    <v-icon small>
                      {{ ordenacao === 'codCliente' ? (ordenacaoDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                    </v-icon>
                  </th>
                  <th
                    id="dadoMovimentacaoHeader"
                    style="text-align: center;"
                    class="black--text title"
                    @click="mudarOrdenacao('cliente')"
                  >
                    Razão Social
                    <v-icon small>
                      {{ ordenacao === 'cliente' ? (ordenacaoDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                    </v-icon>
                  </th>
                  <th
                    id="dadoMovimentacaoHeader"
                    style="text-align: center;"
                    class="black--text title"
                    @click="mudarOrdenacao('vendedor')"
                  >
                    Vendedor
                    <v-icon small>
                      {{ ordenacao === 'vendedor' ? (ordenacaoDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                    </v-icon>
                  </th>
                  <th
                    id="dadoMovimentacaoHeader"
                    style="text-align: center;"
                    class="black--text title"
                    @click="mudarOrdenacao('data')"
                  >
                    Data última compra
                    <v-icon small>
                      {{ ordenacao === 'data' ? (ordenacaoDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                    </v-icon>
                  </th>
                  <th
                    id="dadoMovimentacaoHeader"
                    style="text-align: center;"
                    class="black--text title"
                    @click="mudarOrdenacao('valor')"
                  >
                    Valor última compra
                    <v-icon small>
                      {{ ordenacao === 'valor' ? (ordenacaoDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                    </v-icon>
                  </th>
                  <th
                    id="dadoMovimentacaoHeader"
                    style="text-align: center;"
                    class="black--text title"
                    @click="mudarOrdenacao('diasCompra')"
                  >
                    Dias sem compra
                    <v-icon small>
                      {{ ordenacao === 'diasCompra' ? (ordenacaoDecrescente ? 'mdi-arrow-down' : 'mdi-arrow-up') : '' }}
                    </v-icon>
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="item in dadosFiltro.length > 0 ? dadosFiltro : dadosFaturamento"
                  :key="item.id"
                >
                  <td
                    id="dadoMovimentacao"
                    style="text-align: center;"
                  >
                    {{ item.codCliente }}
                  </td>
                  <td
                    id="dadoMovimentacao"
                    style="text-align: left;"
                  >
                    {{ item.cliente }}
                  </td>
                  <td
                    id="dadoMovimentacao"
                    style="text-align: left;"
                  >
                    {{ item.vendedor }}
                  </td>
                  <td
                    id="dadoMovimentacao"
                    style="text-align: center;"
                  >
                    {{ item.dataExibicao }}
                  </td>
                  <td
                    id="dadoMovimentacao"
                    style="text-align: right;"
                  >
                    {{ item.valorExibicao }}
                  </td>
                  <td
                    id="dadoMovimentacao"
                    style="text-align: right;"
                  >
                    {{ item.diasCompra }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </v-col>
        <v-col
          v-if="dadosFaturamento.length > 0"
          cols="12"
          sm="12"
          md="12"
          lg="3"
        >
          <br><br>
          <h4 class="text-center">
            Dias sem compra
          </h4>
          <v-row>
            <v-col
              cols="12"
              sm="1"
              md="1"
              lg="1"
            >
              <div id="minimo">
                {{ minimoFiltro > 0 ? minimoFiltro : minimo }}
              </div>
            </v-col>
            <v-col
              id="rangerId"
              cols="12"
              sm="9"
              md="9"
              lg="9"
            >
              <v-range-slider
                v-model="values"
                :min="minimo"
                :max="maximo"
                color="#424242"
                track-color="grey"
                thumb-label
                class="slider"
                @input="getFiltro"
              />
            </v-col>
            <v-col
              cols="12"
              sm="1"
              md="1"
              lg="1"
            >
              <div id="maximo">
                {{ maximoFiltro > 0 ? maximoFiltro : maximo }}
              </div>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
  import Clientes from '../../../../../services/somentecliente'
  import eventEmit from '../../core/EventoEmit'
  import JSPDF from 'jspdf'
  import 'jspdf-autotable'
  import ExcelJS from 'exceljs'
  import { saveAs } from 'file-saver'

  export default {
    name: 'ShowDadosComparativoFaturamento',
    emits: [],
    components: {
    },
    data: () => ({
      styleObject: {
        color: localStorage.corPrimaria,
      },
      styleSlider: {
        color: '#000000',
      },
      value: 0,
      values: [],
      loading: false,
      error: null,
      primeiroDia: (new Date(new Date().getFullYear(), new Date().getMonth(), 1)).toISOString().substr(0, 10),
      ultimoDia: (new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)).toISOString().substr(0, 10),
      select: [],
      vendedor: [],
      area: [],
      rede: [],
      supervisor: [],
      receita: [],
      segmento: [],
      categoria: [],
      promotor: [],
      classificacao: [],
      linhaProducao: [],
      cidade: [],
      headers: [
        { text: 'Codigo cliente', value: 'codCliente', align: 'left', class: 'black--text title' },
        { text: 'Razão Social', value: 'cliente', align: 'left', class: 'black--text title' },
        { text: 'Vendedor', value: 'vendedor', align: 'left', class: 'black--text title' },
        { text: 'Data última compra', value: 'data', align: 'right', class: 'black--text title' },
        { text: 'Valor última compra', value: 'valor', align: 'right', class: 'black--text title' },
        { text: 'Dias sem compra', value: 'diasCompra', align: 'right', class: 'black--text title' },
      ],
      dadosFaturamento: [],
      dadosFiltro: [],
      minimo: 0,
      maximo: 0,
      minimoFiltro: 0,
      maximoFiltro: 0,
      enableBtn: false,
      corPrimaria: localStorage.corPrimaria,
      imprimindo: false,
      imprimindoExcel: false,
      ordenacao: '',
      ordenacaoDecrescente: false,
    }),

    created () {
      eventEmit.$on('update-dados-filtros', this.handleUpdateDados)
    },

    beforeDestroy () {
      eventEmit.$off('update-dados-filtros', this.handleUpdateDados)
    },

    methods: {
      handleUpdateDados (primeiroDia, dataFinal, select, vendedor, area, rede, supervisor, receita, segmento, categoria, promotor, classificacao, cidade, linhaProducao) {
        this.primeiroDia = primeiroDia
        this.ultimoDia = dataFinal
        this.select = select
        this.vendedor = vendedor
        this.area = area
        this.rede = rede
        this.supervisor = supervisor
        this.receita = receita
        this.segmento = segmento
        this.categoria = categoria
        this.promotor = promotor
        this.classificacao = classificacao
        this.linhaProducao = linhaProducao
        this.cidade = cidade

        this.atualizaDados()
      },

      async atualizaDados () {
        this.loading = true
        this.dadosFaturamento = []
        this.minimo = 0
        this.maximo = 0
        this.value = 0
        this.values = []
        this.minimoFiltro = 0
        this.maximoFiltro = 0
        this.enableBtn = false
        this.ordenacao = ''
        this.ordenacaoDecrescente = false

        await Clientes.showBaseAtendimentoCliente(this.primeiroDia, this.ultimoDia, this.select, this.supervisor, this.area, this.rede, this.vendedor, this.receita, localStorage.tokencontrato, this.segmento, this.categoria, this.promotor, this.classificacao, this.cidade, this.linhaProducao).then(resposta => {
          if (resposta.data.status) {
            this.dadosFaturamento = resposta.data.dadosFaturamento.map((item) => {
              var listaDadosFaturamento = ({
                codCliente: item.codCliente,
                cliente: item.cliente,
                vendedor: item.vendedor,
                data: item.data,
                dataExibicao: item.dataExibicao,
                valor: item.valor,
                valorExibicao: item.valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
                diasCompra: item.diasCompra,
              })

              return listaDadosFaturamento
            }).sort((d1, d2) => d2.diasCompra - d1.diasCompra)

            this.minimo = this.dadosFaturamento[this.dadosFaturamento.length - 1].diasCompra
            this.values.push(this.minimo)

            this.maximo = this.dadosFaturamento[0].diasCompra
            this.values.push(this.maximo)

            this.enableBtn = true
          } else if (resposta.data.msg === 'Não dados de valores a pagar para fornecedores no período selecionado') {
            this.showSnackbar('error', 3000, resposta.data.msg)
          }
        }).catch(e => {
          if (e.message === 'Network Error') {
            this.error = e.message

            this.showSnackbar('error', 3000, 'Falha na conexão com a internet')
          }
        }).finally(f => { this.loading = false })
      },

      getFiltro () {
        const valorMinimo = this.values[0]
        const valorMaximo = this.values[1]

        this.minimoFiltro = this.values[0]
        this.maximoFiltro = this.values[1]

        if (valorMinimo === this.minimo && valorMaximo === this.maximo) {
          this.minimoFiltro = 0
          this.maximoFiltro = 0

          this.dadosFiltro = []
        } else {
          this.dadosFiltro = this.dadosFaturamento
            .filter(item => item.diasCompra >= valorMinimo && item.diasCompra <= valorMaximo)
            .sort((d1, d2) => d2.diasCompra - d1.diasCompra)
        }
      },

      mudarOrdenacao (campo) {
        if (this.ordenacao === campo) {
          this.ordenacaoDecrescente = !this.ordenacaoDecrescente
        } else {
          this.ordenacao = campo
          this.ordenacaoDecrescente = false
        }

        this.atualizarOrdemTabela()
      },

      atualizarOrdemTabela () {
        const novaOrdenacao = [...this.dadosFaturamento]

        novaOrdenacao.sort((a, b) => {
          let result = 0

          if (a[this.ordenacao] < b[this.ordenacao]) result = -1
          if (a[this.ordenacao] > b[this.ordenacao]) result = 1

          if (this.ordenacaoDecrescente) result *= -1

          return result
        })

        this.dadosFaturamento = novaOrdenacao

        if (this.dadosFiltro.length > 0) {
          const novaOrdenacaofiltro = [...this.dadosFiltro]

          novaOrdenacaofiltro.sort((a, b) => {
            let resultFiltro = 0

            if (a[this.ordenacao] < b[this.ordenacao]) resultFiltro = -1
            if (a[this.ordenacao] > b[this.ordenacao]) resultFiltro = 1

            if (this.ordenacaoDecrescente) resultFiltro *= -1

            return resultFiltro
          })

          this.dadosFiltro = novaOrdenacaofiltro
        }
      },

      async imprimirPdf () {
        try {
          this.imprimindo = true

          await setTimeout(() => {
            this.print()
          }, 2000)
        } catch (error) {
          console.error('Erro ao imprimir:', error)
        }
      },

      async print () {
        try {
          const pdf = new JSPDF('landscape', 'mm')

          let posYFiltros = 10

          const title = 'Filtros selecionados'

          pdf.text(title, 105, posYFiltros)

          const dataInicial = this.primeiroDia.substr(8) + '/' + this.primeiroDia.substr(5, 2) + '/' + this.primeiroDia.substr(0, 4)

          const ultimoDia = this.ultimoDia.substr(8) + '/' + this.ultimoDia.substr(5, 2) + '/' + this.ultimoDia.substr(0, 4)

          const datas = 'Data inicial: ' + dataInicial + ' - Data final: ' + ultimoDia

          posYFiltros += 10

          pdf.setFontSize(10)

          pdf.text(datas, 15, posYFiltros)

          posYFiltros += 10

          const adicionarFiltros = async (pdf, posYFiltros, titulo, dados) => {
            if (dados.length > 0) {
              let texto = titulo + ' '

              for (let i = 0; i < dados.length; i++) {
                texto += dados[i] + ', '
              }

              texto = texto.slice(0, -2)

              const linhas = this.quebrarString(texto, 135)

              linhas.forEach((linha, index) => {
                if (posYFiltros === 200) {
                  pdf.addPage()

                  posYFiltros = 10

                  pdf.text(linha, 15, posYFiltros)

                  posYFiltros += 10
                } else {
                  pdf.text(linha, 15, posYFiltros)

                  posYFiltros += 10
                }
              })
            }

            return posYFiltros
          }

          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Empresa(s) Selecionada(s):', this.select.map(e => e.nomeExibicao))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Vendedor(es) Selecionado(s):', this.vendedor.map(v => v.vendedor))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Área(s) Selecionada(s):', this.area.map(a => a.area))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Rede(s) Selecionada(s):', this.rede.map(r => r.rede))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Supervisor(es) Selecionado(s):', this.supervisor.map(s => s.supervisor))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Receita(s) Selecionada(s):', this.receita.map(re => re.nome))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Segmento(s) Selecionado(s):', this.segmento.map(se => se.segmento))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Classificação(ões) Selecionada(s):', this.classificacao.map(c => c.classificacao))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Linha(s) Produção Selecionada(s):', this.linhaProducao.map(l => l.linhaProducao))
          posYFiltros = await adicionarFiltros(pdf, posYFiltros, 'Cidade(s) Selecionada(s):', this.cidade.map(c => c.cidade))

          if (posYFiltros > 80) {
            pdf.addPage()

            posYFiltros = 10
          }

          posYFiltros += 10

          const titleDados = 'BASE ATENDIMENTO'

          pdf.text(titleDados, 105, posYFiltros)

          posYFiltros += 10

          const tableAux = this.dadosFiltro.length > 0 ? this.dadosFiltro : this.dadosFaturamento

          const tableBaseAtendimento = tableAux.map(item => [
            item.codCliente,
            item.cliente,
            item.vendedor,
            item.data,
            item.valor,
            item.diasCompra,
          ])

          pdf.autoTable({
            head: [this.headers.map(header => ({ content: header.text, styles: { fontSize: 10, textColor: [0, 0, 0] } }))],
            body: tableBaseAtendimento.map(row => row.map((cell, index) => {
              const isFaturamentoColumn = index === 4 || index === 5
              return {
                content: cell,
                styles: {
                  fontSize: 8,
                  textColor: [0, 0, 0],
                  halign: isFaturamentoColumn ? 'right' : 'left',
                },
              }
            })),
            startY: posYFiltros,
            styles: { fontSize: 10 },
            theme: 'grid',
            tableWidth: 'auto',
          })

          pdf.save('relatorio_base_atendimento.pdf')
        } catch (error) {
          console.error('Erro ao gerar PDF:', error)
        } finally {
          this.imprimindo = false
        }
      },

      quebrarString (str, limiteCaracteresPorLinha) {
        const palavras = str.split(' ')
        let linhaAtual = ''
        const linhas = []

        palavras.forEach(palavra => {
          if ((linhaAtual + palavra).length <= limiteCaracteresPorLinha) {
            linhaAtual += palavra + ' '
          } else {
            linhas.push(linhaAtual.trim())
            linhaAtual = palavra + ' '
          }
        })

        if (linhaAtual !== '') {
          linhas.push(linhaAtual.trim())
        }

        return linhas
      },

      async exportExcel () {
        try {
          this.imprimindoExcel = true

          await setTimeout(() => {
            this.printExcel()
          }, 2000)
        } catch (error) {
          console.error('Erro ao exportar excel', error)
        }
      },

      async printExcel () {
        try {
          const workbook = new ExcelJS.Workbook()
          const worksheet = workbook.addWorksheet('Relatório Base Atendimento')

          let posY = 1

          const inserirTitulo = (worksheet) => {
            worksheet.mergeCells(`A${posY}:D${posY}`)
            worksheet.getCell(`A${posY}`).value = 'Filtros selecionados'
            worksheet.getCell(`A${posY}`).font = { size: 14, bold: true }
            worksheet.getCell(`A${posY}`).alignment = { vertical: 'middle', horizontal: 'left' }

            posY += 2

            const dataInicial = this.primeiroDia.substr(8) + '/' + this.primeiroDia.substr(5, 2) + '/' + this.primeiroDia.substr(0, 4)
            const ultimoDia = this.ultimoDia.substr(8) + '/' + this.ultimoDia.substr(5, 2) + '/' + this.ultimoDia.substr(0, 4)
            worksheet.mergeCells(`A${posY}:D${posY}`)
            worksheet.getCell(`A${posY}`).value = `Data inicial: ${dataInicial} - Data final: ${ultimoDia}`
            worksheet.getCell(`A${posY}`).font = { size: 10 }
            worksheet.getCell(`A${posY}`).alignment = { vertical: 'middle', horizontal: 'left' }

            posY += 2

            const adicionarFiltros = (worksheet, posY, titulo, dados) => {
              if (dados.length > 0) {
                const texto = titulo + ' ' + dados.join(', ')

                worksheet.getCell(`A${posY}`).value = texto
                worksheet.getCell(`A${posY}`).font = { size: 10 }
                worksheet.getCell(`A${posY}`).alignment = { vertical: 'middle', horizontal: 'left' }

                return posY + 1
              }
              return posY
            }

            posY = adicionarFiltros(worksheet, posY, 'Empresa(s) Selecionada(s):', this.select.map(e => e.nomeExibicao))
            posY = adicionarFiltros(worksheet, posY, 'Supervisor(es) Selecionado(s):', this.supervisor.map(s => s.supervisor))
            posY = adicionarFiltros(worksheet, posY, 'Área(s) Selecionada(s):', this.area.map(a => a.area))
            posY = adicionarFiltros(worksheet, posY, 'Rede(s) Selecionada(s):', this.rede.map(r => r.rede))
            posY = adicionarFiltros(worksheet, posY, 'Vendedor(es) Selecionado(s):', this.vendedor.map(v => v.vendedor))
            posY = adicionarFiltros(worksheet, posY, 'Receita(s) Selecionada(s):', this.receita.map(re => re.nome))
            posY = adicionarFiltros(worksheet, posY, 'Segmento(s) Selecionado(s):', this.segmento.map(se => se.segmento))
            posY = adicionarFiltros(worksheet, posY, 'Classificação(ões) Selecionada(s):', this.classificacao.map(c => c.classificacao))
            posY = adicionarFiltros(worksheet, posY, 'Linha(s) Produção Selecionada(s):', this.linhaProducao.map(l => l.linhaProducao))
            posY = adicionarFiltros(worksheet, posY, 'Cidade(s) Selecionada(s):', this.cidade.map(c => c.cidade))

            posY += 1

            worksheet.addRow([])
          }

          posY += 1

          const ajustarLarguraColunas = (worksheet, headers, tableData) => {
            headers.forEach((header, i) => {
              let maxColumnWidth = header.length
              tableData.forEach(row => {
                const columnText = row[i] ? row[i].toString() : ''
                maxColumnWidth = Math.max(maxColumnWidth, columnText.length)
              })
              worksheet.getColumn(i + 1).width = maxColumnWidth + 2
            })
          }

          inserirTitulo(worksheet)

          posY += 2

          const tableHeaders = this.headers.map(header => header.text)

          const tableAux = this.dadosFiltro.length > 0 ? this.dadosFiltro : this.dadosFaturamento

          const tableData = tableAux.map(item => [
            item.codCliente,
            item.cliente,
            item.vendedor,
            item.data,
            item.valor,
            item.diasCompra,
          ])

          worksheet.addRow(tableHeaders).font = { bold: true }
          tableData.forEach(row => worksheet.addRow(row))
          posY += tableData.length + 1

          ajustarLarguraColunas(worksheet, tableHeaders, tableData)

          const buffer = await workbook.xlsx.writeBuffer()
          saveAs(new Blob([buffer]), 'relatorio_base_atendimento.xlsx')
        } catch (error) {
          console.error('Erro ao gerar Excel:', error)
        } finally {
          this.imprimindoExcel = false
        }
      },
    },
  }
</script>

<style scoped>
  @media screen
  and (min-device-width : 320px)
  and (max-device-width : 680px) {
    #minimo {
      margin: 1.4rem 0 0 -0.5rem !important;
      font-size: 12px;
    }

    #maximo {
      margin: -5rem 0 0 27.8rem !important;
      font-size: 12px;
    }

    #rangerId {
      margin: -3.5rem 0 0 0 !important;
    }

    #idTable {
      max-height: 500px;
      max-width: 98% !important;
      margin: 0 0 0 -0.3rem;
    }

    #dadoMovimentacao {
      font-size: 8.5px;
    }

    th, td {
      padding: 8px;
      word-wrap: break-word;
      white-space: normal;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }

  @media screen
  and (min-width : 681px)
  and (max-width : 960px)
  and (-webkit-min-device-pixel-ratio: 1) {

  }

  @media screen
  and (min-width : 600)
  and (max-width : 1000px)
  and (-webkit-min-device-pixel-ratio: 1) {
  }

  @media screen
  and (min-width : 1001px)
  and (max-width : 1280px)
  and (-webkit-min-device-pixel-ratio: 1) {
    #btnPdf {
      margin: 0 4rem 0 2rem !important;
    }
  }

  @media screen
  and (min-width : 1380px)
  and (max-width : 1600px)
  and (-webkit-min-device-pixel-ratio: 1) {
    #btnPdf {
      margin: 0 4rem 0 2rem !important;
    }
  }

  @media screen
  and (min-width : 1601px)
  and (-webkit-min-device-pixel-ratio: 1) {
    #btnPdf {
      margin: 0 1rem 0 2rem !important;
    }
  }

  #idTable {
    overflow-x: auto;
    overflow-y: auto;
    max-height: 600px;
  }

   #dadoMovimentacao {
    font-size: 12px;
  }

  table {
    width: 100%;
    border-collapse: collapse;
    font-family: Roboto, sans-serif;
    border: 1px solid #e0e0e0;
  }

  thead th {
    position: sticky;
    top: 0;
    z-index: 2;
    background-color: #f5f5f5;
  }

  th, td {
    border: 1px solid #e0e0e0;
    padding: 10px;
    color: #424242;
    word-wrap: break-word;
    white-space: normal;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  thead {
    background-color: #f5f5f5;
  }

  tbody tr:hover {
    background-color: #f0f0f0;
  }

  #dadoMovimentacaoHeader {
    font-size: 12px !important;
    font-weight: 800 !important;
  }

  #btnPdf {
    margin: 0 4rem 0 2rem;
  }

  #btnExcel {
    margin: 0 0 0 0;
  }

  #minimo {
    margin: 0.4rem -2rem 0 0rem;
  }

  #maximo {
    margin: 0.4rem -3rem 0 -1rem;
  }

  #textTable {
    font-size: 0.75rem !important
  }

  .slider >>> .v-slider__thumb-label {
    background-color: rgba(40, 99, 175, 0.6) !important;
    color: white !important;
    font-weight: bold;
    border-radius: 4px;
    bottom: -65px !important;
    top: auto !important
  }

  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
    @-moz-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-webkit-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @-o-keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)

    @keyframes loader
      from
        transform: rotate(0)

      to
        transform: rotate(360deg)
  }
</style>
